import script from './SdsLogo.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo"},[(_vm.destination === undefined)?_c('SdsSkeleton'):_c('CustomRouterLink',{staticClass:"e2e-logo sds-focus",attrs:{"destination":_vm.destination}},[(_vm.shouldShowLogo)?_c('Illustration',{class:"header-logo__image",attrs:{"image":_vm.altLogoUrl}}):_vm._e()],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-c2e27ff0_0", { source: ".header-logo[data-v-c2e27ff0]{position:relative;display:flex;align-items:center;justify-content:center;width:102px;height:18px;padding-inline:8px;border-radius:var(--radius-sm);cursor:pointer}.header-logo[data-v-c2e27ff0]:hover{background-color:var(--component-global-header-bg-overlay-hover)}.header-logo[data-v-c2e27ff0]:active{background-color:var(--component-global-header-bg-overlay-pressed)}.header-logo .header-logo__image[data-v-c2e27ff0]{display:block;width:102px;height:18px}@media only screen and (min-width:1280px){.header-logo[data-v-c2e27ff0]{width:174px;height:40px}.header-logo .header-logo__image[data-v-c2e27ff0]{width:158px;height:28px}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-c2e27ff0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
